import service from '@/utils/request'; // UpdateBairunSvcBalance 更新储值卡主卡
// @Tags Svc
// @Summary 更新储值卡主卡
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalance true "更新储值卡主卡"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /svcManage/svcBalance/update [put]

export var updateBairunSvcBalance = function updateBairunSvcBalance(data) {
  return service({
    url: '/svcManage/svcBalance/update',
    method: 'put',
    data: data
  });
}; // FindBairunSvcBalance 查找储值卡主卡
// @Tags Svc
// @Summary 查找储值卡主卡
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalance true "查找储值卡主卡"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /svcManage/svcBalance/find [get]

export var findBairunSvcBalance = function findBairunSvcBalance(params) {
  return service({
    url: '/svcManage/svcBalance/find',
    method: 'get',
    params: params
  });
};
export var findBairunSvcBalanceByNumber = function findBairunSvcBalanceByNumber(params) {
  return service({
    url: '/svcManage/svcBalance/findByNumber',
    method: 'get',
    params: params
  });
}; // GetBairunSvcBalanceList 分页获取储值卡主卡数据
// @Tags Svc
// @Summary 分页获取储值卡主卡数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.BairunSvcBalanceSearch true "分页获取储值卡主卡数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /svcManage/svcBalance/getList [get]

export var getBairunSvcBalanceList = function getBairunSvcBalanceList(params) {
  return service({
    url: '/svcManage/svcBalance/getList',
    method: 'get',
    params: params
  });
}; // updateBairunSvcBalanceStatus 启用禁用储值卡主卡状态
// @Tags Svc
// @Summary 启用禁用储值卡主卡状态
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "启用禁用储值卡主卡状态"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /svcManage/svcBalance/open/close [post]

export var updateBairunSvcBalanceStatus = function updateBairunSvcBalanceStatus(data) {
  return service({
    url: '/svcManage/svcBalance/open/close',
    method: 'post',
    data: data
  });
}; // RechargeBairunSvcBalance 储值卡主卡充值
// @Tags Svc
// @Summary 储值卡主卡充值
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "储值卡主卡充值"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"充值"}"
// @Router /svcManage/svcBalance/recharge [post]

export var rechargeBairunSvcBalance = function rechargeBairunSvcBalance(data) {
  return service({
    url: '/svcManage/svcBalance/recharge',
    method: 'post',
    data: data
  });
};
export var creditBairunSvcBalance = function creditBairunSvcBalance(data) {
  return service({
    url: '/svcManage/svcBalance/credit',
    method: 'post',
    data: data
  });
};
export var creditSvcBalance = function creditSvcBalance(data) {
  return service({
    url: '/svcManage/svcBalance/create',
    method: 'post',
    data: data
  });
};
export var loseBairunSvcBalance = function loseBairunSvcBalance(data) {
  return service({
    url: '/bairunSvcBalance/loseBairunSvcBalance',
    method: 'post',
    data: data
  });
};